import { FMSInterface, FMSLocationData, FMSServiceReturnData, FMSType, FMSValidAuth, SpaceInterface, UnitInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

export class LegacyServerAPI {
  static async processScheduledMessage(
    // path: { fms: FMSType; facilityId: string },
    body: { data: any },
    params?: any,
  ): Promise<FMSServiceReturnData<UnitInterface[]>> {
    return APIService.LegacyServer.post(`/processor/process-scheduled-message`, body, params);
  }
}
